// Provider chain — outermost first:
//   I18nextProvider gives every component access to the translator.
//   RouterProvider drives navigation.
//
// No AuthProvider / QueryClientProvider — the marketing site is public and
// static (no OIDC, no data layer). i18n is already initialized in main.tsx
// before this mounts, so the first paint speaks the resolved locale.

import { I18nextProvider } from "react-i18next";
import { RouterProvider } from "react-router";

import { i18n } from "@/i18n";
import { router } from "@/router";

export function App(): React.ReactElement {
  return (
    <I18nextProvider i18n={i18n}>
      <RouterProvider router={router} />
    </I18nextProvider>
  );
}
